import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import SmimeContext from '../store/schema/SmimeContext';

class SmimeCustomError extends Error {
    public errorCode: SmimeErrorStateEnum;
    public errorContext: SmimeContext;

    constructor(message: string, errorCode: SmimeErrorStateEnum, errorContext?: SmimeContext) {
        super(message);
        this.errorCode = errorCode;
        this.errorContext = errorContext;
    }
}

export default SmimeCustomError;
